<app-nav-menu *ngIf="_localService.isMenu"></app-nav-menu>
<div [ngClass]="_localService.isMenu ? 'content-body' : ''">
    <router-outlet></router-outlet>
</div>
<footer *ngIf="_localService.isFooter"></footer>
